import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function StickyReferCTA() {
  const { pathname } = useLocation();
  if (pathname === "/professionals") return null;
  return (
    <Link
      to="/professionals"
      data-testid="sticky-refer-cta"
      className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2 rounded-full bg-ink-900 hover:bg-brand text-white pl-5 pr-4 py-3 text-sm font-semibold shadow-xl shadow-slate-900/20 transition-colors"
    >
      Refer a client
      <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white/15">
        <ArrowUpRight className="w-4 h-4" />
      </span>
    </Link>
  );
}
